module.exports = __webpack_public_path__ + "img/click-to-unlock-button.75110180.gif";